require('./_wks-define')('asyncIterator');



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/modules/es7.symbol.async-iterator.js
// module id = 282
// module chunks = 0 1 2 3 4